import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import DropDown from '../../Ui/DropDown';

let options = [
    {label: 'Pickup Passport', value: 'Pickup Passport'},
    {label: 'Delivery Passport', value: 'Delivery Passport'}
];

const Modal = ({ t, type, title, jobTitle, jobData, status, showModal, loading, setSelectedStatus, handleOk, handleCancel, footerOption1, footerOption2 }) => (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '')}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="close border-0 rounded-2 p-1" aria-label="Close" onClick={handleCancel}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-body">
                       {(type === 'notification') ? <div>
                                <p>{jobTitle}</p>
                                <div>
                                    {Object.entries(jobData).map(([key, value]) =>
                                       <p key={key}>{key}: {value}</p>
                                    )}
                                </div>
                            </div>
                        : (type === 'delivery' ? <div>
                            <p>{t("jobsManagement.infoJob.createDeliveryRequest.type")}</p>
                            <DropDown placeholder={t("jobsManagement.infoJob.createDeliveryRequest.typePlaceholder")} options={options} onChange={(value) => console.log(value)} />
                        </div> : <div>
                            <p className="mb-2">{t("jobsManagement.infoJob.updateJobStatus.selectStatus")}</p>
                            <button onClick={() => setSelectedStatus('completed')} disabled={status === 'completed'} className="btn btn-success me-2" style={{borderRadius: '3px'}}>{t("jobsManagement.infoJob.updateJobStatus.completed")}</button>
                            <button onClick={() => setSelectedStatus('cancel')} disabled={status === 'cancel'} className="btn btn-danger" style={{borderRadius: '3px'}}>{t("jobsManagement.infoJob.updateJobStatus.cancel")}</button>
                        </div>)}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : t("sideNav.newJobRequest.close")}</button>
                        <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleOk}>{footerOption1 ? footerOption1 : t("sideNav.newJobRequest.ok")}
                            {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop show"></div>
    </div>
);

export default Modal;